import React from 'react';

import { CleaningPrestation } from '@front/common/src/types/commons';
import { BasketState } from '@front/common/src/ducks/common/basket';
import colors from '@front/common/src/utils/colors';
import { formatPrice, formatPricePerHour, formatPricePerMonth } from '@front/common/src/utils/formatting';
import { getCurrentCountry } from '@front/common/src/utils/country';

import { MEMBERSHIP_CONFIG_BY_COUNTRY } from '@front/customer/src/constants/country-config';
import { Price } from '@front/customer/src/types/prices';

import { translate } from '@front/i18n';

import Text from '@front/web-ui/src/components/base-text/variants/text';
import Title from '@front/web-ui/src/components/base-text/variants/title';
import TextButton from '@front/web-ui/src/components/button/text-button';

const t = translate('basket.membership.card');

type PaidMembershipProps = {
  getMoreInfoPress: () => void;
  reduction: Price;
  duration: BasketState['duration'];
  cleaningPrestation?: CleaningPrestation;
};

const PaidMembership = ({ reduction, getMoreInfoPress, duration, cleaningPrestation }: PaidMembershipProps) => {
  const membershipMonthlyPrice = MEMBERSHIP_CONFIG_BY_COUNTRY[getCurrentCountry()].monthlyPrice;
  const cleaningPrestationTitle = cleaningPrestation?.title.toLowerCase() || '';

  if (!cleaningPrestation?.is_recurrent) {
    return (
      <span>
        <Text.SMMedium>{`${t('.reductions.happy')} `}</Text.SMMedium>
        <Text.SMMedium>{`${t('.recurring.has_paid_membership.spot_cleaning.text_1')} `}</Text.SMMedium>
        <Title color={colors.pink120}>
          {`${duration ? formatPrice(reduction.price) : formatPricePerHour(reduction.hourly_price, { precision: 0 })} `}
        </Title>
        <Text.SMMedium>
          {t('.recurring.has_paid_membership.spot_cleaning.text_2', { prestation: cleaningPrestationTitle })}
        </Text.SMMedium>
      </span>
    );
  }

  return (
    <span>
      <Text.SMMedium>{`${t('.recurring.has_paid_membership.recurring_cleaning.text_1', { prestation: cleaningPrestationTitle })} `}</Text.SMMedium>
      <TextButton size='sm' onClick={getMoreInfoPress}>
        {t('.more_info_link.wecasa_club')}
      </TextButton>
      <Text.SMMedium>{` ${t('.recurring.has_paid_membership.recurring_cleaning.text_2')} `}</Text.SMMedium>
      <Text.SMBold color={colors.pink120}>
        {t('.recurring.has_paid_membership.recurring_cleaning.text_3')}
      </Text.SMBold>
      <Text.SMMedium>
        {` ${t('.recurring.has_paid_membership.recurring_cleaning.text_4', {
          pricePerMonth: formatPricePerMonth(membershipMonthlyPrice),
        })}`}
      </Text.SMMedium>
    </span>
  );
};

export default PaidMembership;
